module.exports = __webpack_public_path__ + "static/img/app-store-phone.d71d49f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/app-of-the-day/images/app-store-phone.png
// module id = DA9D
// module chunks = 26